import { useEffect, useState } from 'react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Bot } from 'lucide-react'
import { toast } from 'sonner'
import { fetchChatbotContext, updateChatbotContext } from '../api'
import { Button } from './ui/button'
import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from './ui/card'
import { Skeleton } from './ui/skeleton'

interface Props {
  sociedadId: string
}

// Solo visible para el Dueño de la Sociedad (KnowledgeBasePage ya filtra por
// rank antes de montar esto) — el backend re-gatea lo mismo, esto es solo UX.
export function ChatbotContextPanel({ sociedadId }: Props) {
  const queryClient = useQueryClient()
  const [text, setText] = useState('')

  const query = useQuery({
    queryKey: ['chatbot-context', sociedadId],
    queryFn: () => fetchChatbotContext(sociedadId),
  })

  useEffect(() => {
    if (query.data) setText(query.data.chatbot_context ?? '')
  }, [query.data])

  const mutation = useMutation({
    mutationFn: () => updateChatbotContext(sociedadId, text),
    onSuccess: (data) => {
      queryClient.setQueryData(['chatbot-context', sociedadId], data)
      toast.success('Contexto del chatbot actualizado.')
    },
    onError: () => toast.error('No se pudo guardar el contexto. Intentá de nuevo.'),
  })

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <Bot className="size-4" />
          Contexto del chatbot
        </CardTitle>
        <CardDescription>
          Contale al agente a qué se dedica tu negocio (ej. "veterinaria", "agencia de viajes", "hospital") para
          acotar sus respuestas a ese rubro.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {query.isLoading ? (
          <Skeleton className="h-28 w-full" />
        ) : (
          <textarea
            rows={5}
            maxLength={4000}
            placeholder="Ej: Somos una veterinaria en San José. Solo respondé preguntas sobre citas, vacunas y cuidado de mascotas."
            value={text}
            onChange={(e) => setText(e.target.value)}
            className="w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-xs outline-none focus-visible:ring-2 focus-visible:ring-ring"
          />
        )}
      </CardContent>
      <CardFooter className="justify-end border-t">
        <Button type="button" onClick={() => mutation.mutate()} disabled={mutation.isPending || query.isLoading}>
          Guardar contexto
        </Button>
      </CardFooter>
    </Card>
  )
}
